/**
 * Cloudflare Turnstile 위젯 래퍼 컴포넌트
 *
 * `@marsidev/react-turnstile` 위젯을 감싸 사이트 키와 공통 옵션을 주입합니다.
 * 서버 액션은 `cf-turnstile-response` 필드를 통해 토큰을 받아 검증합니다.
 *
 * 사용 환경 변수:
 * - VITE_TURNSTILE_SITE_KEY
 */
import type { ComponentProps } from "react";

import { Turnstile } from "@marsidev/react-turnstile";
import { useTranslation } from "react-i18next";

type TurnstileProps = ComponentProps<typeof Turnstile>;

interface TurnstileWidgetProps {
  className?: string;
  onSuccess?: TurnstileProps["onSuccess"];
  onError?: TurnstileProps["onError"];
  onExpire?: TurnstileProps["onExpire"];
  options?: TurnstileProps["options"];
}

export default function TurnstileWidget({
  className,
  onSuccess,
  onError,
  onExpire,
  options,
}: TurnstileWidgetProps) {
  const { i18n } = useTranslation();
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;

  if (!siteKey) {
    if (import.meta.env.DEV) {
      console.warn(
        "[turnstile] VITE_TURNSTILE_SITE_KEY 환경 변수가 설정되지 않았습니다.",
      );
    }
    return null;
  }

  return (
    <div className={`flex w-full min-w-0 justify-center ${className ?? ""}`}>
      <Turnstile
        siteKey={siteKey}
        onSuccess={onSuccess}
        onError={onError}
        onExpire={onExpire}
        options={{
          theme: "auto",
          size: "flexible",
          language: i18n.language,
          ...options,
        }}
      />
    </div>
  );
}
